<mat-dialog-content class="overflow-hidden" style="max-height:inherit">
    <div class="d-flex justify-content-between">
        <h5 class="fw-semibold">Digital I/O vom Gerät:&nbsp;{{ deviceName }}</h5>
        <img class="ms-3 avs-modal-close-btn mb-1" width="30" src="assets/icons/x.svg" alt="close-modal-icon"
            (click)="onCloseDialogClicked()">
    </div>
    <div class="d-flex justify-content-center align-items-center mb-4">
        Von vor&nbsp;
        <input class="ms-1 me-1 form-control rounded-0 form-control-sm" style="width: 70px" type="number"
            [(ngModel)]="fromDate" (ngModelChange)="setFromDate(fromDate)" min="1" max="14"> 
        Tagen&nbsp;bis zu&nbsp;
        <input class="ms-1 me-1 form-control rounded-0 form-control-sm" style="width: 70px" type="number"
            [(ngModel)]="toDate" (ngModelChange)="setToDate(toDate)" min="0" max="13">
            &nbsp;Tagen
        <button (click)="removeData()" class="btn rounded-0 btn-outline-success ms-5   ms-sm-5 btn-sm"> Update
        </button>
    </div>
    <div class="d-flex justify-content-between align-items-center mb-4">
        <ng-container *ngFor="let ioChannel of ioChannelsActive | keyvalue; let i = index">
            <div class="d-flex justify-content-left align-items-center mb-4">
                <mat-checkbox [checked]="isActive(ioChannel.key)" (click)="changeCheckValue(ioChannel.key)"></mat-checkbox>
                <avs-text-input
                    [value]="chartDefs[ioChannel.key]['title']"
                    (valueChange)="onChannelNameChange($event, ioChannel.key)"
                    [required]="false">
				</avs-text-input>
            </div>
        </ng-container>
    </div>

    <div class="h-75 overflow-auto">
        <div class="h-100 d-flex flex-column justify-content-between align-items-center p-4">
           <ng-container *ngFor="let ioChannel of ioChannelsActive | keyvalue">
                <canvas id="{{ioChannel.key}}" [hidden]="!ioChannel.value"></canvas>
            </ng-container>
        </div>
    </div>
</mat-dialog-content>
<div mat-dialog-actions class="d-flex justify-content-between m-4">
    <button (click)="exportChart()" class="btn rounded-0 btn-outline-success btn-sm"> Export
    </button>
    <button (click)="onCloseDialogClicked()" class="btn rounded-0 btn-outline-danger btn-sm">
        Schließen
    </button>
</div>

<!--
<canvas id="{{ioChannel.key}}" [hidden]="!ioChannel.value"></canvas>-->